import React, { useEffect } from "react"

import { HalvaFooter } from "@ecom/ui/components/HalvaFooter"
import { HeaderWithBurger } from "@ecom/ui/components/Header/HeaderWithBurger"
import useMediaQuery from "@material-ui/core/useMediaQuery"

import loadable from "@loadable/component"
import LazyHydrate from "react-lazy-hydration"
import Layout, { PageLayoutProps } from "../components/Layouts/mainPage"
import { BannerProps } from "../components/Seo/Banner"
import { Breadcrumbs } from "../components/Breadcrumbs"
import { Banner as BannerDebetCards } from "../components/Seo/BannerDebetCards"
import { HowSteps } from "../components/HowSteps"
import { BetterHalva } from "../components/BetterHalva"
import ComparisonDebetTable from "../components/ComparisonDebetTable"
import { NewCalculator } from "../components/NewCalculator"
import { SwitcherTextBlock } from "../components/SwitcherTextBlock"
import { NewSeoOtherOffers } from "../components/NewSeoOtherOffers"
import { BlackHalvaLogoV2 } from "../components/Headers/Logos"
import { FormPKW } from "../components/FormPKW"

import debetTags from "../static/debetTags.json"

import headerLinksV2 from "../data/dataHeader/headerLinksV2.json"
import footerLinksV2 from "../data/dataFooter/footerLinksV2.json"

import { renderLinkList } from "./helpers/renderLinkList"
import { createSeoData } from "./helpers/createSeoData"
import { CardsList } from "../components/CardsList"
import { DEBET_CARDS_LIST } from "../components/CardsList/data"
import { handleClickHeader } from "../helpers/WatcherDL/utils/handleClickHeader"
import { DLClickEventExtended } from "../helpers/WatcherDL/DLEvents"

const Reviews = loadable(() => import("../components/Reviews"))

const titleForm = (
  <>
    Оформите карту сейчас – <br /> получите подарок!
  </>
)

const ESIALoginTitle = "Получите карту легко"

const ESIALoginDescription = <>Быстро, просто и безопасно через&nbsp;Госуслуги!</>

interface Tags {
  name: string
  seos?: {
    shortTitle: string
    url: string
  }[]
}

const betterDefaultTitle = "Почему карта «Халва» лучше дебетовой карты?"

type Props = {
  pageContext: {
    url: string
    title: PageLayoutProps["title"]
    shortTitle?: string
    description: PageLayoutProps["description"]
    upperBannerText: BannerProps["html"]
    remoteImage: BannerProps["large"]
    remoteImageMob: BannerProps["mob"]
    betterHalvaTitle?: string
    newCalculatorTitle?: string
    howToGetCardTitle?: string
    cardsListTitle?: string
    formTitle?: string
    switcherTextBlockTitle?: string
    seoBlockText?: string
    shortSeoBlockText: string
    phones?: string[]
    noIndex: boolean
    hasOtherPercents: boolean
    ligal: string
    variables: {
      halvaOstatok: {
        value: string
      }
    }
    listing?: {
      items: {
        image: string
        title: string
        description: string
        ctaButton?: string
        ctaButtonTitle?: string
        moreDetails?: string
        moreDetailsTitle?: string
      }[]
    }
  }
}

// Время для таймер(30мин)
const countDownTime = 1800000

export default function Seo({ pageContext }: Props) {
  const {
    upperBannerText,
    url,
    title,
    shortTitle,
    description,
    shortSeoBlockText,
    noIndex,
    listing,
    betterHalvaTitle,
    newCalculatorTitle,
    howToGetCardTitle,
    cardsListTitle,
    switcherTextBlockTitle,
  } = pageContext

  const otherOffersTags: Tags[] = debetTags
  const otherOffersTitle: string = "Другие предложения по картам"
  const breakpointColumnsObj: any = {
    default: 2,
  }

  const linkList = renderLinkList(url, shortTitle)
  const isDesktop = useMediaQuery("(min-width:1279px)")

  const seoData = createSeoData(title, description, upperBannerText, url, shortTitle)

  const cardsListItems = listing?.items[0]?.title ? listing.items : DEBET_CARDS_LIST

  // Получение первой страницы на которую зашел
  useEffect(() => {
    if (!sessionStorage.getItem("firstURL")) {
      sessionStorage.setItem("firstURL", document.URL)
    }
  }, [])

  const onClick = () => {
    DLClickEventExtended({ name: "Логотип", eventAction: "Клик на логотип", placement: "header" })
    window.open("https://halvacard.ru/", "_blank")
  }

  return (
    <Layout noHeader noFooter seoData={seoData} noIndex={noIndex}>
      <HeaderWithBurger
        Logo={BlackHalvaLogoV2}
        onLogoClick={onClick}
        onSidebarBtnClick={() => handleClickHeader("click_cta", "burger_menu")}
        onHeaderBtnClick={() => handleClickHeader("click_cta", "header")}
        orderNum="99"
        listLinksForNav={headerLinksV2}
        anotherStylesTypeV2
        isCountdown
        withButton={isDesktop}
      />
      {linkList && <Breadcrumbs linkList={linkList} orderNum="1" />}
      <BannerDebetCards html={upperBannerText} orderNum="2" />
      <LazyHydrate whenVisible>
        <BetterHalva orderNum="3" title={betterHalvaTitle || betterDefaultTitle} />
      </LazyHydrate>
      <ComparisonDebetTable orderNum="4" />
      <LazyHydrate whenVisible={{ rootMargin: "1000px" }}>
        <NewCalculator title={newCalculatorTitle && newCalculatorTitle} orderNum="5" />
      </LazyHydrate>
      <LazyHydrate whenVisible>
        <HowSteps title={howToGetCardTitle && howToGetCardTitle} orderNum="6" />
      </LazyHydrate>
      <LazyHydrate whenIdle>
        <FormPKW
          title={titleForm}
          dataLayerName="shortPersonalForm"
          orderNum="7"
          formBtnText="Оформить карту"
          progressBar
          longTitle
          countDownTime={countDownTime}
          withTimer
          isGreenApprove
          hasESIA
          ESIALoginTitle={ESIALoginTitle}
          ESIALoginDescription={ESIALoginDescription}
        />
      </LazyHydrate>
      <LazyHydrate whenVisible>
        <CardsList
          orderNum="8"
          dataContent={cardsListItems}
          headTitle={cardsListTitle || "Сравните сами дебетовую карту с картой рассрочки* «Халва»"}
        />
      </LazyHydrate>
      <LazyHydrate whenVisible>
        <SwitcherTextBlock
          title={switcherTextBlockTitle && switcherTextBlockTitle}
          seoBlockText={shortSeoBlockText}
          orderNum="9"
          mode="debet"
        />
      </LazyHydrate>
      <Reviews orderNum="10" page="debet" />
      {otherOffersTags && (
        <LazyHydrate whenVisible>
          <NewSeoOtherOffers
            pageUrl={url}
            title={otherOffersTitle}
            tags={otherOffersTags}
            breakpointColumnsObj={breakpointColumnsObj}
            orderNum="11"
          />
        </LazyHydrate>
      )}
      <LazyHydrate whenVisible>
        <HalvaFooter listLinksForFooter={footerLinksV2} />
      </LazyHydrate>
    </Layout>
  )
}
